import { baseClient } from '../common';
import { MenuModel } from './menu.model';

const apiUrl = `/api/menu`;

export const menuClient = {
  get: (shopId: string, placeId: string): Promise<MenuModel> => {
    return baseClient.get<MenuModel>(`${apiUrl}/${shopId}/place/${placeId}`);
  },
};
